import { createContext } from "react";
import type { RSSFeed } from "@/types/feed";
import type { RSSFeedItem } from "@/types/feedItem";

// Create context to share state between routes
export interface AppContextType {
  selectedFeed: RSSFeed | null;
  selectedItem: RSSFeedItem | null;
  setSelectedFeed: (feed: RSSFeed | null) => void;
  setSelectedItem: (item: RSSFeedItem | null) => void;
}

export const AppContext = createContext<AppContextType | null>(null);
